import { render, staticRenderFns } from "./ConfirmReservationModal.vue?vue&type=template&id=4d46c146&scoped=true&"
import script from "./ConfirmReservationModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmReservationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46c146",
  null
  
)

export default component.exports